<template>
  <div class="remote-consultation clearfix">
    <div class="remote-consultation-wrap">
      <div class="tab_change">
        <button
          :class="[{ tab_active: activeName == 'toDepartment' }, {button: activeName != 'toDepartment'}]"
          @click="changeTab('toDepartment')"
        v-if="isShowTodayDept==1">
          今日科室门诊
        </button>
        <button
          :class="[{ tab_active: activeName == 'toOperate' }, {button: activeName != 'toOperate'}]"
          @click="changeTab('toOperate')"
          :isGetData="isGetData"
        >
          今日网络门诊
        </button>
        <button
          :class="[{ tab_active: activeName == 'toBrowse' }, {button: activeName != 'toBrowse'}]"
          @click="changeTab('toBrowse')"
        >
          未来七天门诊
        </button>
        <button
          :class="[{ tab_active: activeName == 'toBrowseOld' }, {button: activeName != 'toBrowseOld'}]"
          @click="changeTab('toBrowseOld')"
        >
          历史门诊
        </button>
<!--        <button-->
<!--          :class="[{ tab_active: activeName == 'findPrescription' }, {button: activeName != 'findPrescription'}]"-->
<!--          @click="changeTab('findPrescription')"-->
<!--        >-->
<!--          处方查询-->
<!--        </button>-->
      </div>
      <div class="tabLine-content">
        <!--今日科室门诊标签内容-->
        <div v-if="activeName=='toDepartment'">
          <DepartmentList @toOperate="changetoOperate"></DepartmentList>
        </div>
        <!--今日网络门诊标签内容-->
        <div v-show="activeName == 'toOperate'">
          <!--<ClinicOnLineTableCmp1 :propsTableData="contentData1" @fresh="getData" @test3Tee="test3Tee" v-loading="!isSuccess"/>-->
          <ClinicOnLineTableCmp1 :propsTableData="contentData1" @fresh="getData"/>
        </div>
        <!--未来七天门诊标签内容-->
        <div v-show="activeName == 'toBrowse'">
          <ClinicOnLineTableCmp2 :propsTableData="contentData2" v-loading="!isSuccess"/>
          <FooterCmp
            :propsTotalCols="propsTotalCols"
            :clientH="clientH"
            @changePage="changePage2"
            :propsPageSize="10"
          />
        </div>
        <!--历史门诊标签内容-->
        <div v-show="activeName == 'toBrowseOld'">
          <ClinicOnLineTableCmp3 :propsTableData="contentData3" v-loading="!isSuccess" />
          <FooterCmp
            :propsTotalCols="propsTotalCols"
            :clientH="clientH"
            @changePage="changePage3"
            :propsPageSize="10"
          />
        </div>
        <!--查询处方-->
        <div v-show="activeName == 'findPrescription'">
          <ClinicOnLineTableCmp4 :propsTableData="contentData4" v-loading="!isSuccess" />
          <FooterCmp
            :propsTotalCols="propsTotalCols"
            :clientH="clientH"
            @changePage="changePage4"
            :propsPageSize="10"
          />
        </div>
        <div
          :class="['video-show', { 'box-shirink': isShirink }]"
          v-show="showBox1"
          ref="videoBox"
        >
          <video autoplay width="280" height="280" id="checkVideo" ref="video"></video>
          <audio autoplay id="checkAudio"></audio>
          <div class="btns">
            <span class="blue-color" @click="shirinkToggle" v-show="isShirink">
              <svg class="icon">
                <use xlink:href="#icon-zuixiaohua"></use>
              </svg>
            </span>
            <span class="blue-color" @click="shirinkToggle" v-show="!isShirink">
              <svg class="icon">
                <use xlink:href="#icon-zuidahua"></use>
              </svg>
            </span>
            <span class="red-color" @click="leaveRoom">
              <svg class="icon">
                <use xlink:href="#icon-guanbi"></use>
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style></style>
<script>
import { MessageBox } from "element-ui";
import ClinicOnLineTableCmp1 from "./ClinicOnLineTableCmp1.vue";
import ClinicOnLineTableCmp2 from "./ClinicOnLineTableCmp2.vue";
import ClinicOnLineTableCmp3 from "./ClinicOnLineTableCmp3.vue";
import ClinicOnLineTableCmp4 from "./ClinicOnLineTableCmp4.vue";
import DepartmentList from "./DepartmentList.vue";
import { timeStampFormat } from "../../utils/DateFormat.js";
import FooterCmp from "../common/FooterCmp.vue";
import T from "lmw-time-format";

export default {
  data: function () {
    return {
      page: {},
      activeName: "toDepartment", //切换标签的值
      isSuccess: false, //是否加载成功
      searchKey: "", // 搜索内容
      propsTotalCols: 0, //列表总数量
      contentData1: [], //今日网络门诊
      contentData2: [], //未来七天门诊
      contentData3: [], //历史门诊
      contentData4: [], //处方查询
      tdate: "",
      docId: "",
      hosId: "",
      currentPage1: 1, //列表1当前页数
      currentPage2: 1, //列表2当前页数
      currentPage3: 1, //列表3当前页数
      currentPage4: 1, //列表3当前页数
      // currentPage4: 1,//列表4当前页数
      showBox1: false,
      isShirink: false,
      isGetData: false,
      lis: {
        ddid: "666888",
        ddzt: "0",
        numno: "123456",
        numtime: "2018-09-23",
        hzxm: "姜春华",
        hosPatid: "236666",
        sjh: "13656568989",
        ksmc: "测试科",
        ysmc: "测试医生",
      }, //模拟数据
      isShowTodayDept: 0,
    };
  },
  props: ["clientH"],
  created: function () {
    this.tdate = timeStampFormat("yyyy-MM-dd");
    this.getDocId();
  },
  mounted: function () {
    this.$store.dispatch("isGetNewMsg_ychz_wfq", false); // 清除小红点
    this.$store.dispatch("changeSideItem", "wlmz"); // 侧边栏高亮
    //fleet
    //2023年7月6日
    this.isShowTodayDept = window.sessionStorage.getItem("isShowTodayDept")
  },
  components: {
    ClinicOnLineTableCmp1,
    ClinicOnLineTableCmp2,
    ClinicOnLineTableCmp3,
    ClinicOnLineTableCmp4,
    DepartmentList,
    FooterCmp,
  },
  computed: {
    isGetNewMsg_ychz_wfq: function () {
      // 我发起
      return this.$store.state.isGetNewMsg_ychz_wfq;
    },
    isGetNewMsg_ychz_wsd: function () {
      // 我收到
      return this.$store.state.isGetNewMsg_ychz_wsd;
    },
  },
  methods: {
    changetoOperate(){
      //标签切换
      this.searchKey = "";
      this.activeName = 'toOperate';
      this.getTabList('toOperate', this.searchKey, 1);
    },
    async getDocId() {
      let options = {
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        token: localStorage.getItem("token"),
      };
      let data = await this.$http("smarthos.user.book.doc.list", options);
      if (!data.list || data.list.length === 0) {
        return this.$message.error("该业务医生未绑定挂号医生");
      }
      let id = JSON.parse(sessionStorage.getItem("loginInfo")).doc.hosId;
      // for(let i = 0; i<data.list.length; i++){
      //     if(id==data.list[i].bookHosId){
      //         this.docId = data.list[i].bookDocId;
      //         this.hosId = data.list[i].bookHosId;
      //     }
      // }
      this.docId = data.list[0].bookDocId;
      this.hosId = data.list[0].bookHosId;
      // this.getData( this.tdate,this.tdate, "contentData1",8);
      this.getDataToDay(this.tdate, this.tdate, "contentData1", "");
    },
    async getDataToDay(
      bdate = "",
      edate = "",
      contentDataType = "contentData1",
      pageNum = 1,
      pageSize = 100
    ) {
      //获取数据 函数封装避免重复代码
      if (!this.hosId || !this.docId) {
        return this.$message.error("该业务医生未绑定挂号医生");
      }
      let options = {
        docId: JSON.parse(sessionStorage.getItem("loginInfo")).doc.id,
        // hosid:this.hosId,
        // ysid:this.docId,
        bdate: bdate,
        edate: edate,
        // pageNum: pageNum,
        // pageSize: 7,
        token: localStorage.getItem("token"),
      };
      //let data = await this.$http("smarthos.yygh.ApiDoctorService.orderByYsid",options);
      let data = await this.$http(
        "smarthos.online.outpatient.pack.list.v1",
        // "smarthos.online.outpatient.pack.list",
        options
      );
      this.isSuccess = true;
      // this.contentData1 = bespeakList;
      this.contentData1 = data.obj.list;
      this.$store.dispatch("enterVideoList", data.obj.list);
      // this.$store.dispatch("enterVideoList",['2966']);
      this.isGetData = true;
    },
    async getData(
        bdate = "",
        edate = "",
        contentDataType = "contentData1",
        pageNum = 1,
        service="smarthos.online.outpatient.pack.list.v1",
        pageSize = 100
    ) {
      //获取数据 函数封装避免重复代码
      if (!this.hosId || !this.docId) {
        return this.$message.error("该业务医生未绑定挂号医生");
      }
      let userInfo=JSON.parse(sessionStorage.getItem("loginInfo"))
      let options = {
        bdate: bdate,
        edate: edate,
        docId: userInfo.doc.id,
        // hosid:this.hosId,
        // ysid:this.docId,
        pageNum: pageNum,
        pageSize: 10,
        token: localStorage.getItem("token"),
        hosId: userInfo.doc.hosId
      };

      let data = await this.$http(
          service,
          // "smarthos.online.outpatient.pack.list",
          options
      );
      this.isSuccess = true;
      this.page = data.obj.page;
      switch (
          contentDataType //根据切换的标签获取不同数据
          ) {
        case "contentData1":
          this.contentData1 = data.obj.list;
          this.propsTotalCols = data.obj.page.total;
          // this.contentData1 = testData;
          break;
        case "contentData2":
          this.contentData2 = data.obj.list;
          this.propsTotalCols = data.obj.page.total;
          break;
        case "contentData3":
          this.contentData3 = data.obj.list;
          this.propsTotalCols = data.obj.page.total;
          break;
        case "contentData4":
          this.contentData4 = data.obj.list;
          this.propsTotalCols = data.obj.page.total;
          break;
      }
      this.propsTotalCols = parseInt(this.propsTotalCols);
    },
    getTabList: function (tabName, searchKey = "", pageNo = 1) {
      // 获取列表
      this.isSuccess = false;
      let now, bdate, edate;
      switch (tabName) {
        case "toOperate": //今日网络门诊
          // this.$store.dispatch("isGetNewMsg_ychz_wfq", false);// 清除小红点
          this.getDataToDay(this.tdate, this.tdate, "contentData1", "");
          // this.getData( "2018-03-04","2018-06-22", "contentData1",pageNo);
          break;
        case "toBrowse": //未来七天门诊
          now = Date.now() + 24 * 3600 * 1000;
          bdate = T(now, "%Y-%m-%d");
          edate = T(now + 7 * 24 * 3600 * 1000, "%Y-%m-%d");
          // this.$store.dispatch("isGetNewMsg_ychz_wsd", false);// 清除小红点
          this.getData(bdate, edate, "contentData2", pageNo);
          break;
        case "toBrowseOld": //历史门诊
          now = Date.now();
          bdate = T(now - 365 * 24 * 3600 * 1000, "%Y-%m-%d");
          edate = T(now, "%Y-%m-%d");
          // this.$store.dispatch("isGetNewMsg_ychz_wsd", false);// 清除小红点
          this.getData(bdate, edate, "contentData3", pageNo);
          break;
        case "findPrescription": //查询处方
          now = Date.now();
          bdate = T(now - 365 * 24 * 3600 * 1000, "%Y-%m-%d");
          edate = T(now, "%Y-%m-%d");
          this.getData(bdate, edate, "contentData4", pageNo, "smarthos.outside.hospital.recipe.order.list");
          break;
      }
    },
    changeTab: function (tab) {
      //标签切换
      this.searchKey = "";
      this.activeName = tab;
      this.getTabList(tab, this.searchKey, 1);
    },
    changePage1: function (pageNo) {
      //各个标签改变页数
      this.currentPage1 = pageNo;
      this.getTabList(this.activeName, this.searchKey, pageNo);
    },
    changePage2: function (pageNo) {
      this.currentPage2 = pageNo;
      this.getTabList(this.activeName, this.searchKey, pageNo);
    },
    changePage3: function (pageNo) {
      this.currentPage3 = pageNo;
      this.getTabList(this.activeName, this.searchKey, pageNo);
    },
    changePage4: function (pageNo) {
      console.log(`=====changePage4========>`,pageNo)
      this.currentPage4 = pageNo;
      this.getTabList(this.activeName, this.searchKey, pageNo);
    },
    /*splitDataArr: function(contentData, currentPage ,num){//分割数组，参数1：需要分割的数组，参数2：对应表单的当前页数，参数3：列表每页显示的行数(需要css样式列表高度配合),
            const totalsCols = contentData.length;
            const start = (currentPage - 1) * num;
            //end如果大于数组总长度则数值改为数组总长度
            const end = (currentPage * num > totalsCols) ? totalsCols : (currentPage * num);
            return contentData.slice(start, end);
        },*/
    searchHandler: function () {
      // 搜索内容
      this.getTabList(this.activeName, this.searchKey, 1);
    },
    // test3Tee(){
    //     let _this = this;
    //     _this.isShirink = false;
    //     var obj = {};
    //     obj.bookDocId = JSON.parse(sessionStorage.getItem("loginInfo")).doc.bookDocId,
    //     obj.docName = JSON.parse(sessionStorage.getItem("loginInfo")).doc.docName;
    //     var checkVideo = document.getElementById("checkVideo");
    //     var checkAudio = document.getElementById("checkAudio");
    //     MessageBox.confirm('是否确认进入诊间？', '提示',{
    //         confirmButtonText: '确定',
    //         cancelButtonText:'取消',
    //         type: 'warning'
    //     }).then(()=>{
    //         setTimeout(function () {
    //             _this.showBox1 = true;
    //         },3000);
    //         joinRoom("15015015000",obj.bookDocId,obj.docName,"","",checkVideo,checkAudio);
    //         // joinRoom("64570800899",obj.bookDocId,obj.docName,"","",checkVideo,checkAudio);
    //     })
    // },
    shirinkToggle() {
      this.isShirink = !this.isShirink;
    },
    leaveRoom() {
      MessageBox.confirm("是否确认退出视频？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        leaveRoom();
        this.showBox1 = false;
      });
    },
  },
};
</script>
<style scoped>
.remote-consultation-wrap .tab_change .button {
  color: #FFFFFF;
  background-color: #01abac;
}
</style>